import React, { useMemo } from 'react'
import useOfferTags from 'hooks/Offers/useOfferTags'
import { ContentTagPage } from './contentTagTypes'
import ContentTagLabel from './ContentTagLabel'

interface Props {
  /**
   * The offer ID to fetch tags from.
   */
  offerId?: string
  /**
   * The page context for generating the content tag slug.
   * - 'offer' generates slugs like 'offer-pill-<tag_name>'
   * - 'search' generates slugs like 'search-pill-<tag_name>'
   */
  page: ContentTagPage
}

/**
 * Displays promotion labels based on offer tags.
 * Converts each tag name to a slug format and renders a ContentTagLabel for each.
 */
function ContentTagLabels({ offerId, page }: Props) {
  const { tags: offerTags } = useOfferTags(offerId)

  const tagSlugs = useMemo(() => {
    return offerTags.map(tag => {
      // No normalization of tag name here, it should be the same as the same as tag name in admin portal
      return `${page}-pill-${tag.name}`
    })
  }, [offerTags, page])

  if (tagSlugs.length === 0) {
    return null
  }

  return (
    <>
      {tagSlugs.map(slug => (
        <ContentTagLabel key={slug} slug={slug} />
      ))}
    </>
  )
}

export default ContentTagLabels
